import { render, staticRenderFns } from "./DialogBuddyInsurance.vue?vue&type=template&id=0a07804a&scoped=true"
import script from "./DialogBuddyInsurance.vue?vue&type=script&lang=js"
export * from "./DialogBuddyInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a07804a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a07804a')) {
      api.createRecord('0a07804a', component.options)
    } else {
      api.reload('0a07804a', component.options)
    }
    module.hot.accept("./DialogBuddyInsurance.vue?vue&type=template&id=0a07804a&scoped=true", function () {
      api.rerender('0a07804a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_buddy_insurance/DialogBuddyInsurance.vue"
export default component.exports